import React from "react";
import InvestmentWrapper from "../common/InvestmentWrapper/InvestmentWrapper";
import { BOND } from "../../../constants";

const Bonds = ({ history }) => {
	return <InvestmentWrapper type={BOND} history={history} />;
};

export default Bonds;
